<template>
    <Appstore/>
</template>

<script>
import { Appstore } from 'shared'

export default {
    name: 'appstore4',
    components: {
        Appstore
    },
    created() {
        this.$store.commit('getAppId', [
            {
                value: 6004,
                label: '体育'
            }
        ])
    }
}
</script>